import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as t } from "../../core/maybe.js";

var s = /*#__PURE__*/function () {
  function s() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var e = arguments.length > 2 ? arguments[2] : undefined;
    var o = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, s);

    this.geometry = t, this.attributes = _s, this.centroid = e, this.objectId = o, this.displayId = 0, this.geohashX = 0, this.geohashY = 0;
  }

  _createClass(s, [{
    key: "weakClone",
    value: function weakClone() {
      var t = new s(this.geometry, this.attributes, this.centroid, this.objectId);
      return t.displayId = this.displayId, t.geohashX = this.geohashX, t.geohashY = this.geohashY, t;
    }
  }]);

  return s;
}();

function e(s) {
  return !(t(s.geometry) || !s.geometry.coords || !s.geometry.coords.length);
}

var o = /*#__PURE__*/function (_s2) {
  _inherits(o, _s2);

  var _super = _createSuper(o);

  function o() {
    _classCallCheck(this, o);

    return _super.apply(this, arguments);
  }

  return o;
}(s);

export { o as OptimizedFeatureWithGeometry, s as default, e as hasGeometry };